<p-confirmDialog #cd class="confirmation-dialogue text-inline">
    <ng-template pTemplate="header">
        <div>Confirmation</div>
    </ng-template>
    <img alt="warningImage" class="warning-img" src="{{assetsUrl}}noun_Warning_3775442.png">
    <ng-template pTemplate="footer">
        <div class="btnHolder">
            <button type="button" class="primaryBtn" (click)="cd.accept()">
              <img alt="tickImage" src="{{assetsUrl}}tick (3).png">  Yes</button>
            <button type="button" class="SecondaryBtn" (click)="cd.reject()">
                <img alt="closeImage" src="{{assetsUrl}}close (1).png">  No</button>
        </div>
    </ng-template>
</p-confirmDialog>